import type { TargetFunction } from '../store/reducers/workspace.reducer.ts';
import { UnitSystem } from '../types/util.ts';

const METERS_TO_FEET = 3.280839895;

const isImperial = (unitSystem: UnitSystem): boolean => unitSystem === UnitSystem.IMPERIAL;

export const getLengthUnitLabel = (unitSystem: UnitSystem): string => (isImperial(unitSystem) ? 'ft' : 'm');

export const toDisplayLength = (meters: number, unitSystem: UnitSystem): number =>
  isImperial(unitSystem) ? meters * METERS_TO_FEET : meters;

export const fromDisplayLength = (displayLength: number, unitSystem: UnitSystem): number =>
  isImperial(unitSystem) ? displayLength / METERS_TO_FEET : displayLength;

export const getLengthInputStep = (unitSystem: UnitSystem): number => (isImperial(unitSystem) ? 0.5 : 0.1);

export const formatLength = (meters: number, unitSystem: UnitSystem, fractionDigits = 2): string =>
  toDisplayLength(meters, unitSystem).toFixed(fractionDigits);

export const formatPoint = (
  point: readonly [number, number, number],
  unitSystem: UnitSystem,
  fractionDigits = 2,
): string =>
  `(${formatLength(point[0], unitSystem, fractionDigits)}, ${formatLength(point[1], unitSystem, fractionDigits)}, ${formatLength(point[2], unitSystem, fractionDigits)})`;

export const getPhotometricUnit = (func: TargetFunction): string | null => {
  switch (func) {
    case 'E':
    case 'Ev':
    case 'Esc':
    case 'Ehs':
      return 'lx';
    case 'L':
      return 'cd/m²';
    default:
      return null;
  }
};
